import { CellContext } from '@tanstack/react-table';
import { memo } from 'react';
import { getFormTableFieldName } from './utils';
import { FormField } from '../../FormField';
import { FormTableSequenceNumberInput } from '../FormTableSequenceNumberInput';

interface FormSequenceNumberFieldProps<RowData>
  extends CellContext<RowData, any> {
  onRangeChange?: (parentPath: string, start: number, end?: number) => void;
}

export const FormTableSequenceNumberField = (memo as <T>(c: T) => T)(
  <RowData,>(props: FormSequenceNumberFieldProps<RowData>) => {
    const name = getFormTableFieldName(props);
    return (
      <FormField name={name} size="small" preview={{ ellipsis: false }}>
        <FormTableSequenceNumberInput
          size="small"
          name={name}
          autoFocus
          onRangeChange={props.onRangeChange}
        />
      </FormField>
    );
  }
);

export const FormTableReadonlySequenceNumberField = (memo as <T>(c: T) => T)(
  <RowData,>(props: FormSequenceNumberFieldProps<RowData>) => {
    const name = getFormTableFieldName(props);
    return (
      <FormField name={name} size="small" preview={{ ellipsis: false }}>
        <FormTableSequenceNumberInput
          size="small"
          name={name}
          onRangeChange={props.onRangeChange}
          readOnly
        />
      </FormField>
    );
  }
);
